export default __webpack_public_path__ + "static/media/male@2x.be1a06e3.png";